<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          @click:outside="closeModal"
          :retain-focus="false"
          width="1000"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                Supplier Details
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="black--text mt-10">
              <v-row>
                <v-col cols="6">
                  <div class="d-flex flex-row">
                    <img
                      style="width: 100px; height: 100px; border-radius: 50%"
                      :src="supplierData.profilePic ? supplierData.profilePic : '/img/No_Image_Available.jpg'"
                      alt="John"
                    />
                    <div class="pa-5 person-title">
                      <h3>{{ supplierData.supplierName }}</h3>
                      <p class="mb-0 mt-1">
                       Country : {{ supplierData.countryId }}
                      </p>
                      <p class="mb-0 mt-1">
                       Zip : {{ supplierData.zipcode }}
                      </p>
                    </div>
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="d-flex flex-row-reverse">
                    <v-btn @click="editSupplier" right height="44" color="primary" class="px-5">
                      Edit Supplier
                    </v-btn>
                    <v-btn
                      outlined
                      class="pa-5 mr-5"
                      right
                      height="44"
                      depressed
                      color="error"
                      @click="removeSupplier"
                    >
                      Remove Supplier
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row
                align="center"
                justify="space-around"
                style="background-color: #f3f3f3"
                class="py-4 contact"
              >
                <div>
                  Phone Number <br /><strong>{{ supplierData.phoneNo }}</strong>
                </div>
                <div>
                  Email Address <br /><strong>{{ supplierData.email }}</strong>
                </div>
                <div>
                  License Number(GST Number)<br /><strong>License No.
                  {{ supplierData.licenseNumber }}</strong>
                </div>
                <div>No.of Items<br /><strong>{{ supplierData.supplierIngredient.length }}</strong></div>
              </v-row>
              <v-row class="mt-8">
                <v-col cols="12">
                  <h3>About Supplier</h3>
                <p>
                  {{ supplierData.about }}
                </p>
                </v-col>
              </v-row>
              <v-row>
                <v-card style="width: 100%">
                  <v-data-table
                    class="pa-3"
                    :headers="headers"
                    :items="supplierData.supplierIngredient"
                    :items-per-page="5"
                    hide-default-footer
                    :header-props="{
                      'sort-icon': 'mdi-unfold-more-horizontal',
                    }"
                  >
                    <template v-slot:top>
                      <div class="d-flex my-5">
                        <p class="mt-2 ml-4 font-weight-bold">Items List</p>
                      </div>
                    </template>
                    <template v-slot:[`item.ingredient`]="{ item }">
                      {{ item.ingredient.name }}
                    </template>
                    <template v-slot:[`item.cost`]="{ item }">
                      {{ item.cost }}
                    </template>
                    <template v-slot:[`item.tax`]="{ item }">
                      {{ item.tax }}
                    </template>
                  </v-data-table>
                </v-card>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import { supplier } from "@/graphql/Supplier.gql";
export default {
  apollo: {
    supplier: {
      query: supplier,
      fetchPolicy: "network-only",
      variables() {
        return {
          id: Number(this.supplierID),
        };
      },
      update: (data) => data.supplier,
      result({ data }) {
        this.supplierData = data.supplier;
      },
    },
   
    
  },
  created(){
    this.startLoading();
    setTimeout(() => {
      this.stopLoading();
    }, 2000);
  },
  data() {
    return {
      supplierData: {
        supplierName: null,
        phoneNo: null,
        email: null,
        licenseNumber: null,
        logoUrl: null,
        about:null,
        supplierIngredient:[]
      },
      headers: [
        {
          text: "Feed Ingredients Name",
          value: "ingredient",
          class: "black--text",
        },
        {
          text: "Cost/Unit",
          value: "cost",
          class: "black--text",
        },
        {
          text: "Tax/Unit",
          value: "tax",
          class: "black--text",
        },
      ],
    };
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    supplierID: {
      type: Number,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },

    async removeSupplier() {
      this.startLoading();
      this.$emit("removeSupplier",this.supplierID)
      this.$emit("closeDialog");
      this.stopLoading();
    
    },
    
    async editSupplier(){
      this.$emit("editSupplier",this.supplierID);
    }
  },
  mixins: [loadingMixin],
};
</script>

<style>
.theme--light.v-chip:not(.v-chip--active) {
  background: #ffb443;
  color: #ffffff;
}
.contact :not(:last-child) {
    border-right: 1px solid #ccc;
    padding-right: 50px;
}
.person-title h3 {
    font-size: 26px;
    letter-spacing: 0em;
}
</style>
